
<div class="cd-section" id="regulations" style="background-color: white; padding-top:10px;">

    <div class="container-fluid">





        <!-- TWO Section Half -->
        <div class="row top-buffer" style=" margin-top: 10%;">

            <div class="col-md-6">
                <img width="100%" src="../../assets/img/RegScale-Mock2.png" alt="" />

            </div>

            <div class="col-md-6 " style=" margin-top: 10%;">
                <h1  class="trainingHeader"> <b>RegScale Training Coming Soon</b></h1>

                <h5> Aditional RegScale training coming soon for Enterprise and Pro.</h5>
                <div>
                    <a class="btn btn-primary" [routerLink]="['/training']"> Back</a>
                </div>

            </div>

        </div>



</div>
</div>
